import { pb } from './pocketbase';


export const getPromotionsByFormation = async (formationId) => {
    if (!formationId) return [];
    try {
        const records = await pb.collection('promotions').getFullList({
            filter: `formations_id = "${formationId}"`,
            sort: '-created',
        });
        return records;
    } catch (error) {
        console.error("Failed to get promotions by formation:", error);
        throw error;
    }
};


export const createPromotion = async (promotionData) => {
    try {
        if (pb.authStore.isValid && pb.authStore.model) {
            const promotionWithPartnerId = {
                ...promotionData,
                partner_id: pb.authStore.record.partner_id
            };
            const createdPromotion = await pb.collection('promotions').create(promotionWithPartnerId);
            return createdPromotion;
        } else {
            console.error('Aucun utilisateur authentifié. Impossible de créer la promotion sans partner_id.');
            return null;
        }            
    } catch (error) {
        console.error('Erreur lors de la création de la promotion:', error);
        throw error;
    }
};


export const updatePromotion = async (id, data) => {
    try {
        const record = await pb.collection('promotions').update(id, data);
        return record;
    } catch (error) {
        console.error("Failed to update promotion:", error);
        throw error;
    }
};


export const getPromotionById = async (promotionId) => {
    try {
        const record = await pb.collection('promotions').getOne(promotionId);
        return record;
    } catch (error) {
        console.error('Erreur lors de la récupération de la promotion:', error);
        throw error;
    }
};

// Récupérer toutes les promotions
export const getPromotions = async () => {
    try {
        const records = await pb.collection('promotions').getFullList({
            sort: '-created',
            expand: 'formations_id'
        });
        return records;
    } catch (error) {
        console.error("Failed to get promotions:", error);
        throw error;
    }
};

export const deletePromotion = async (id) => {
    try {
        await pb.collection('promotions').delete(id);
    } catch (error) {
        console.error("Failed to delete promotion:", error);
        throw error;
    }
};
